import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useEffect, useState, useRef } from 'react';
import "../../assets/styles/sidebar.css";
import { SuperadminRouteName, AdminRouteName, PartnerRouteName, AffiliateRouteName } from "../../utils/route-name";

const SideBar = () => {
  const { isSidebarOpen } = useSelector(state => state?.commonReducer);
  const { superadminAdminPartnerDetails } = useSelector((state) => state.authReducer);
  const [routeName, setRouteName] = useState([]);
  const [sidebarWidth, setSidebarWidth] = useState(300);

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) setSidebarWidth(300);
      else setSidebarWidth(300);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call to handle resizing

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const startResizing = (e) => {
    console.log("Start Resizing");
    document.addEventListener("mousemove", onResize);
    document.addEventListener("mouseup", stopResizing);
  };

  const onResize = (e) => {
    const newWidth = e.clientX;  // Get mouse position to calculate width
    if (newWidth > 250 && newWidth < 500) setSidebarWidth(newWidth);
  };

  const stopResizing = () => {
    document.removeEventListener("mousemove", onResize);
    document.removeEventListener("mouseup", stopResizing);
  };

  useEffect(() => {
    const role = localStorage.getItem('role');
    const label = localStorage.getItem('label') || superadminAdminPartnerDetails?.label;
    switch (role) {
      case 'Admin':
        setRouteName(AdminRouteName);
        break;

      case 'Partner':
        if (label === 'Affiliate') {
          setRouteName(AffiliateRouteName);
        } else {
          setRouteName(PartnerRouteName);
        }
        break;

      default:
        setRouteName(SuperadminRouteName);
        break;
    }
  }, [superadminAdminPartnerDetails]);

  return (
    <>
      <motion.div animate={{ width: isSidebarOpen ? `${sidebarWidth}px` : '0px' }} className="sidebar" style={{ position: 'relative' }} ref={sidebarRef}  >
        <section style={{ padding: '100px 15px', display: 'flex', flexDirection: 'column', gap: '40px', textWrap: 'nowrap' }}>
          {routeName?.map((section, index) => (
            <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
              <p style={{ fontSize: '13px', padding: '0 5px', marginBottom: '5px' }}>{section?.title}</p>

              {section?.links.map((item, idx) => (
                <NavLink key={idx} to={item?.path} className="navlink">
                  <div style={{ height: '16px', width: '16px' }}>
                    {item.icon}
                  </div>
                  <p>{item?.label}</p>
                </NavLink>
              ))}
            </div>
          ))}
        </section>
      </motion.div>
    </>
  );
};

export default SideBar;